import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:text-white" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_3 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-10"
}
const _hoisted_5 = {
  key: 2,
  class: "mt-10"
}
const _hoisted_6 = { key: 1 }

import BrandCardLayout from '@/layouts/BrandCardLayout.vue'
	import SignInForm from './components/SignInForm.vue'
	import ForgotPasswordForm from './components/ForgotPasswordForm.vue'
	import PasswordExpiredForm from './components/PasswordExpiredForm.vue'
	import RequestAccountForm from './components/RequestAccountForm.vue'

	// router
	import {
		useRoute
	} from "vue-router"

	// vue
	import {
		computed,
		ref
	} from "vue"

	
	const __default__ = { name: 'SignInMain' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// components
	const route = useRoute()
	const passwordExpired = ref(false)

	function showUpdatePassword() {
		passwordExpired.value = true
	}

	// the footer links belong to the sign in form only, not to the other forms this page hosts
	const showSignInLinks = computed(() => {
		return !passwordExpired.value
			&& route.name !== 'RequestAccount'
			&& route.name !== 'ForgotPassword'
			&& route.name !== 'ResetPasswordRequested'
	})

	const pageTitle = computed(() => {
		switch(route.name) {
			case "SignIn": 
				if(passwordExpired.value) return "Update Your Password"
				else return "Customer Login"
			case "ForgotPassword": 
				return "Reset Your Password"
			case "RequestAccount": 
				return "Request Account"
			default:
				return "Customer Login"
		}
	})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_divider_label = _resolveComponent("v-divider-label")!

  return (_openBlock(), _createBlock(BrandCardLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(pageTitle.value), 1),
      (showSignInLinks.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              to: {name: 'RequestAccount'},
              class: "link"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode(" Need an account? Request one to get started ")
              ])),
              _: 1,
              __: [1]
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.$route.name === 'SignIn')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (!passwordExpired.value)
                ? (_openBlock(), _createBlock(SignInForm, {
                    key: 0,
                    onPasswordExpired: _cache[0] || (_cache[0] = ($event: any) => (showUpdatePassword()))
                  }))
                : (_openBlock(), _createBlock(PasswordExpiredForm, { key: 1 }))
            ]))
          : (_ctx.$route.name === 'ForgotPassword' || _ctx.$route.name === 'ResetPasswordRequested')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(ForgotPasswordForm)
              ]))
            : (_ctx.$route.name === 'RequestAccount')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(RequestAccountForm)
                ]))
              : _createCommentVNode("", true)
      ]),
      (showSignInLinks.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_v_divider_label, {
              label: "Or",
              "class-name": "my-6"
            }),
            _createVNode(_component_router_link, {
              to: {name: 'PayInvoice'},
              class: "button btn-white w-full flex"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" Pay an Invoice ")
              ])),
              _: 1,
              __: [2]
            }),
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mt-4 text-sm text-center text-gray-500 dark:text-gray-400" }, " No account required ", -1))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})